import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { CUST_TOKEN, custApi, custLogin, custRegister, custMe } from "./api";

const Ctx = createContext(null);
export const useCustomer = () => useContext(Ctx);

function persist(token) {
  localStorage.setItem(CUST_TOKEN, token);
  custApi.defaults.headers.common.Authorization = `Bearer ${token}`;
}

export function CustomerProvider({ children }) {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);
  const [authOpen, setAuthOpen] = useState(false);

  useEffect(() => {
    (async () => {
      if (localStorage.getItem(CUST_TOKEN)) {
        try { setUser(await custMe()); } catch { localStorage.removeItem(CUST_TOKEN); }
      }
      setReady(true);
    })();
  }, []);

  const login = useCallback(async (email, password) => {
    const d = await custLogin(email, password);
    persist(d.access_token); setUser(d.user); return d.user;
  }, []);

  const register = useCallback(async (body) => {
    const d = await custRegister(body);
    persist(d.access_token); setUser(d.user); return d.user;
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(CUST_TOKEN);
    delete custApi.defaults.headers.common.Authorization;
    setUser(null);
  }, []);

  return (
    <Ctx.Provider value={{ user, ready, login, register, logout, authOpen, setAuthOpen }}>
      {children}
    </Ctx.Provider>
  );
}
